const PaginationActionTypes = {
  CHANGE_PAGE: "CHANGE_PAGE",
  HIDE_SOCIAL: "HIDE_SOCIAL",
  HIDE_PROMO: "HIDE_PROMO",
};

export default PaginationActionTypes;
